import type { MapBlockContent } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface MapBlockEditorProps {
  content: MapBlockContent | null
  onChange: (content: MapBlockContent) => void
}

export function MapBlockEditor({ content, onChange }: MapBlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<MapBlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Map</h3>
        <p className="text-sm text-muted-foreground">
          Embed a map via iframe. Provide an embed URL (e.g. Google Maps embed).
        </p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Heading</Label>
          <Input
            value={c.heading ?? ""}
            onChange={(e) => update({ heading: e.target.value })}
            placeholder="Find us"
          />
        </div>
        <div>
          <Label>Address / Embed URL</Label>
          <Input
            value={c.address ?? ""}
            onChange={(e) => update({ address: e.target.value })}
            placeholder="Address or Google Maps embed URL"
          />
        </div>
        <div>
          <Label>Height</Label>
          <Input
            type="number"
            min={100}
            value={c.height ?? 300}
            onChange={(e) => update({ height: Number(e.target.value) || 300 })}
            placeholder="300"
          />
        </div>
      </CardContent>
    </Card>
  )
}
